<style lang="scss" src='./CourseInfo.scss' scoped></style>
<template src="./CourseInfo.html"></template>

<script>
  import Vue from 'vue';
  import {
    updateCourse,
    updateCourseShopAddress,
    deleteBackgroundImage,
    getFacilityTypes,
    deleteFacility,
    getManagementCompanies,
    getAgents,
  } from '@/api/index';
  import { omit } from 'lodash';
  import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
  import { required } from 'vee-validate/dist/rules';
  
  import { mapMutations, mapState, mapActions } from 'vuex';
  import { Models } from 'gw-js-lib';
  import i18n from './../../../../i18n';
  
  extend('required', required);

  export default {
    name: 'CourseInfo',
    components: {
      ValidationProvider,
      ValidationObserver,
    },

    data() {
      return {
        course: Models.M_facility(),
        backgroundImgs: [],
        logo: Models.M_image(null, null, null),
        autocompleteInput: null,
        autocompleteInputShop: null,
        facilityTypesAvailable: [],
        managementCompanies: [],
        isGolfCourse: false,
        agents: [],
      };
    },
    
    computed: {
      ...mapState('CourseSetup', {
        courseStore: (state) => state.setupData.course,
        loading: (state) => state.loading,
      }),
      ...mapState({
        userCourses: (state) => state.userCourses,
        generalCourseStore: (state) => state.course,
      }),
    },

    watch: {
      courseStore() {
        this.course = {...this.courseStore };
        this.$refs.inpAddress.value = this.course.address; 
        this.$refs.inpShopAddress.value = this.course.shop_address.address;
      },
    },

    methods: {
      formatZones() {
        if(!isNaN(this.course.no_holes)){
          this.course.no_holes = parseInt(this.course.no_holes);
          if(this.course.no_holes <= 0){
            this.course.no_holes = 1;
          }
          if(this.course.no_holes > 72){
            this.course.no_holes = 72
          }
        }else{
          this.course.no_holes = 1;
        }
        
      },
      checkForGolfCourse(){
        if(this.course.facility_type && this.course.facility_type.is_golf_course){
          this.isGolfCourse = true;
          this.course.no_holes = this.course.course_id ? this.course.no_holes : 18;
        }else{
          this.isGolfCourse = false;
          this.course.no_holes = this.course.course_id ? this.course.no_holes : 4;
        }
      },

      GetFacilityName(facility){
        if(facility.i18n.length > 0){
          let text = facility.i18n.find((item)=>{
            if(item.language == this.$i18n.locale){
              return item
            }    
          })

          if(text){
            return text.i18n
          }else{
            return facility.name
          }
        }else{
          return facility.name
        }
      },

      onNewLogoSelected(event) {
        this.G_createUrlFromFile(event, (mImage)=> {
          this.logo = mImage;
        });
      },

      onNewBackgroundSelected(event) {
        this.G_createUrlFromFile(event, (mImage)=> {
          let newImage = mImage;
          this.backgroundImgs.push(newImage);
          document.getElementById("inFileBackground").value = '';
        });
      },

      deleteTempImage(index) {
        this.backgroundImgs.splice(index, 1);
      },
      
      onAddressChanged() {
        const place = this.autocompleteInput.getPlace();
        let invalidAddress = true;
        if (place) {
          if (place.geometry && place.geometry.location) {
            const country_code = this.findInGooglePlaceResult(place.address_components, 'country', 'short_name');
            if (country_code) {
              const latLong = place.geometry.location;
              this.setAddress({ country_code, address: place.formatted_address, latitude: latLong.lat(), longitude: latLong.lng(), 
                                zip_code: this.findInGooglePlaceResult(place.address_components, 'postal_code', 'long_name') });
              invalidAddress = false;
            }
          }
        }

        if (invalidAddress) {
          this.setAddress({ country_code: null, address: null, latitude: null, longitude: null, zip_code: null, });
          Vue.notify({
              type: 'warn',
              text: this.$t('courses.invalidAddress'),
            });
        }
      },

      onShopAddressChanged() {
        const place = this.autocompleteInputShop.getPlace();
        let invalidAddress = true;
        if (place) {
          if (place.geometry && place.geometry.location) {
            const country_code = this.findInGooglePlaceResult(place.address_components, 'country', 'short_name');
            if (country_code) {
              const latLong = place.geometry.location;
              this.setShopAddress({ address: place.formatted_address, latitude: latLong.lat(), longitude: latLong.lng(), 
                                zip_code: this.findInGooglePlaceResult(place.address_components, 'postal_code', 'long_name') });
              invalidAddress = false;
            }
          }
        }

        if (invalidAddress) {
          this.setShopAddress({ address: null, latitude: null, longitude: null, zip_code: null, });
          Vue.notify({
              type: 'warn',
              text: this.$t('courses.invalidAddress'),
            });
        }
      },

      setAddress({country_code, address, latitude, longitude, zip_code}) {
        this.course.country_code = country_code;
        this.course.address = address;
        this.course.latitude = latitude;
        this.course.longitude = longitude;
        this.course.zip_code = zip_code;
      },

      setShopAddress({address, latitude, longitude, zip_code}) {
        this.course.shop_address = {
          address,
          latitude,
          longitude,
          zip_code,
        }
      },

      findInGooglePlaceResult(addressComponents, addressType, field) {
        if (addressComponents && addressComponents.length > 0) {
          const address_component = addressComponents.find(address => address.types.includes(addressType));
          if (address_component) {
            return address_component[field];
          }
        }
      },

      async loadData() {
        await this.loadAvailableFacilityTypes();
        await this.loadManagementCompanies();
        await this.loadAgents();
        this.autocompleteInput = await this.G_initMapPlaces(this.$refs.inpAddress);
        this.autocompleteInputShop = await this.G_initMapPlaces(this.$refs.inpShopAddress);
        this.consts.Google.MAP.maps.event.addListener(this.autocompleteInput, 'place_changed', this.onAddressChanged);
        this.consts.Google.MAP.maps.event.addListener(this.autocompleteInputShop, 'place_changed', this.onShopAddressChanged);
      },

      async continue() {
        const validForm = await this.$refs.validator.validate().then((v) => v);
        if (validForm) {
          this.setSetupData({'course': this.course});
          this.setLogo(this.logo);
          this.setBackgroundImgs(this.backgroundImgs);
        }

        return validForm;
      },

      async fnDeleteCourse() {
        this.setLoading({deletingCourse: true});
        await this.G_Alert_v2({ 
          style: this.consts.Style.DANGER, 
          message: this.$t('courses.deleteConfirmation'),
          fnOk: async () => {
            const course_id = this.course.course_id;
            await deleteFacility(course_id).then((courseUpdated) => {
              if(courseUpdated && courseUpdated.deleted){
                this.$notify({
                  text: i18n.t('courses.courseDeleted'),
                  type: 'success',
                });
                
                let allCourses = [...this.userCourses]
                let idx = allCourses.findIndex(item => item.course_id == course_id);
                
                if(idx >= 0){
                  allCourses.splice(idx, 1);
                  this.$store.commit("setUserCourses", allCourses);

                  if(this.$store.state.course.course_id == course_id){
                    this.$store.commit("setCourse", allCourses[0]);
                  }
                }
                
                this.$router.push('/courses');
              }
            });
            this.setLoading({deletingCourse: false});
          }
        });

        this.setLoading({deletingCourse: false});

      },

      async fnUpdateCourse() {
        if (await this.continue()) {
          this.setLoading({updatingCourse: true});
          try {
            await this.deleteBacgroundImages();
            await this.uploadCourseImages(this.course.course_id);

            let auxCourse = omit(this.course, ['background_images', 'logo_url', 'deleted', 'time_created', 'time_updated', 'facility_type', 'management_company', 'agent']);
            auxCourse.type_id = this.course.facility_type.type_id
            auxCourse.company_id = this.course.management_company ? this.course.management_company.company_id : null; 
            auxCourse.agent_id = this.course.agent ? this.course.agent.agent_id : null;

            const { shop_address, ...newCourseData} = auxCourse;

            await updateCourse(this.course.course_id, newCourseData).then((courseUpdated) => {
              if (courseUpdated.background_images.length > 0) {
                courseUpdated.background_images.map(image => image.deleted = false);
              }
              this.setSetupData({course: courseUpdated});
              this.updateCourse(courseUpdated); // Update course on store
              this.updateUserCourse(courseUpdated); // Update user course on store

              this.cleanImages();
            });

            await updateCourseShopAddress(this.course.course_id, shop_address);
            this.setLoading({updatingCourse: false});
          } catch(err) {
            this.setLoading({updatingCourse: false});
          }
        }
      },

      async deleteBacgroundImages() {
        for (let image of this.course.background_images) {
          if(image.deleted === true) {
            await deleteBackgroundImage(image.image_id);
          }
        }
      },

      cleanImages() {
        this.setLogo(null);
        this.setBackgroundImgs([]);
        this.logo = Models.M_image(null, null, null);
        this.backgroundImgs = [];
      },

      loadAvailableFacilityTypes() {
        getFacilityTypes().then((resp) => {
          if (resp.facility_types && resp.facility_types.length) {
            this.facilityTypesAvailable = resp.facility_types;
            this.course.facility_type = this.courseStore && this.courseStore.facility_type ? 
            this.courseStore.facility_type : this.facilityTypesAvailable[0]
            this.checkForGolfCourse()
          } else {
            this.facilityTypesAvailable = [];
          }
        })
      },

      updSelectedFacilityType(){
        this.checkForGolfCourse()
      },

      loadManagementCompanies() {
        getManagementCompanies().then((resp) => {
          if (resp.management_companies && resp.management_companies.length) {
            this.managementCompanies = resp.management_companies;
            this.course.management_company = this.courseStore && this.courseStore.management_company ? 
            this.courseStore.management_company : null;
          } else {
            this.management_companies = [];
          }
        })
      },

      loadAgents() {
        getAgents().then((resp) => {
          if (resp.agents && resp.agents.length) {
            this.agents = resp.agents;
            this.course.agent = this.courseStore && this.courseStore.agent ? 
            this.courseStore.agent : null;
          } else {
            this.agents = [];
          }
        })
      },

      updSelectedManagementCo() {},

      updSelectedAgent() {},

      ...mapActions('CourseSetup', ['uploadCourseImages']),
      ...mapActions('Courses', ['updateCourse']),
      ...mapActions(['updateUserCourse']),
      ...mapMutations('CourseSetup', ['setCanContinue', 'setCanBack', 'setSetupData', 'setLogo', 'setBackgroundImgs', 'setLoading']),
    },

    activated() {
      this.setCanContinue(this.continue);
      this.setCanBack(null);
    },

    mounted() {
      if (process.env.VUE_APP_SENTRY_ENV == "production") {
        this.$analytics.setCurrentScreen("Web Golf Courses Info");
        this.$analytics.logEvent("web_golf_courses_info");
      }
      this.loadData();
    },

    beforeDestroy() {
    },
  };

</script>
